module.exports = __webpack_public_path__ + "img/morrishall.18341543.jpg";